// CountUp integration for Stats layout using simplified markup
// Each stat number is rendered as: <span class="stat-number-value" data-value="1234">1,234</span><span class="stat-suffix">+</span>
const CountUp = require('countup.js').CountUp;

const Stats = {
	init() {
		try {
			const valueSpans = document.querySelectorAll('.stat-number-value');
			if (!valueSpans.length) return;

			valueSpans.forEach((span) => {
				try {
					// Prefer data-value attribute for clean numeric source; fallback to text
					const raw = span.getAttribute('data-value') || span.textContent || '';
					// Remove grouping commas, leave decimal point
					const normalized = raw.replace(/,/g, '').trim();
					const value = parseFloat(normalized);
					if (isNaN(value)) return;

					const decimalPlaces = (() => {
						const parts = normalized.split('.');
						return parts[1] ? parts[1].length : 0;
					})();

					const options = {
						startVal: 0,
						decimalPlaces,
						duration: 2.5,
						useEasing: true,
						useGrouping: true,
						enableScrollSpy: true,
					};

					const countUp = new CountUp(span, value, options);
					if (countUp.error) console.error('CountUp error:', countUp.error);
				} catch (e) {
					console.error('Error initializing stat count:', e);
				}
			});
		} catch (e) {
			console.error('Stats module init error:', e);
		}
	},
};

module.exports = Stats;
